export default "__VITE_ASSET__c9c618f6__"